import Loading from "../../components/Loading";
import FormSectionTitle from "../../components/styled/FormSectionTitle";
import { RenderFields } from "../../utils/form.utils";

export default function CarField({ watch, control, errors, setValue, others }) {
  const { sl, isMulti } = others ?? {};

  const fields = [
    {
      label: "Name",
      name: isMulti ? `car.${sl}.name` : "car.name",
      type: "text",
      placeholder: "Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Chassis No.",
      name: isMulti ? `car.${sl}.chassis` : "car.chassis",
      type: "text",
      placeholder: "Chassis No.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Engine No.",
      name: isMulti ? `car.${sl}.engine` : "car.engine",
      type: "text",
      placeholder: "Engine No.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Year/Model",
      name: isMulti ? `car.${sl}.year` : "car.year",
      type: "text",
      placeholder: "Year / Model",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Color",
      name: isMulti ? `car.${sl}.color` : "car.color",
      type: "text",
      placeholder: "Color",
      col: { md: 4, lg: 3 }
    },
    {
      label: "CC",
      name: isMulti ? `car.${sl}.cc` : "car.cc",
      type: "text",
      placeholder: "CC",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Fuel",
      name: isMulti ? `car.${sl}.fuel` : "car.fuel",
      type: "text",
      placeholder: "Fuel",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Descriptions",
      name: isMulti ? `car.${sl}.descriptions` : "car.descriptions",
      type: "textarea",
      placeholder: "Descriptions",
      col: { md: 12 }
    },
    {
      label: "Price",
      name: isMulti ? `car.${sl}.price` : "car.price",
      type: "text",
      placeholder: "Price",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Registration Cost",
      name: isMulti ? `car.${sl}.registration_cost` : "car.registration_cost",
      type: "text",
      placeholder: "Registration Cost",
      col: { md: 4, lg: 3 }
    }
  ];

  const isLoading = false;

  return (
    <>
      <div className="col-12">
        <FormSectionTitle>{isMulti ? `${sl + 1}. ` : ""}Vehicle Information</FormSectionTitle>
      </div>
      <Loading loading={isLoading} />
      <RenderFields
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
      />
    </>
  );
}
